import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { DialogV2ComponentModule } from '@y42/core/dialog-v2';
import { IconModule } from '@y42/core/icon';
import { IntercomModule } from '@y42/intercom';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ImageCropDialogComponent } from './image-crop-dialog.component';

@NgModule({
  exports: [ImageCropDialogComponent],
  declarations: [ImageCropDialogComponent],
  imports: [
    CommonModule,
    FormsModule,

    IconModule,
    MatFormFieldModule,
    MatSelectModule,
    MatDividerModule,
    DialogV2ComponentModule,
    MatButtonModule,

    MatFormFieldModule,
    IntercomModule,
    ImageCropperModule,
  ],
})
export class ImageCropDialogModule {}
